<script lang="ts" setup>
import chatTheme from "@/composable/settings/chatTheme";
</script>
<template>
  <MateChat v-if="chatTheme === 'classic'" />
  <MateChatV2 v-else />
</template>
